import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useViewerRoles } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { AddIcon, Button, Input, Label, Modal, Popover } from '@treams/treams-ui';

function CreateDepartmentPopover(props: { onDismiss: () => void }) {
	const { t } = useTranslation();
	const history = useHistory();

	const [name, setName] = useState<string>('');

	const groups = graphql.useGroupsQuery({
		variables: { first: 1000, filter: { types: [graphql.GroupType.Department] } },
	});

	const [create] = graphql.useCreateGroupMutation();

	const parentID = groups.data?.groups.edges
		.map(({ node }) => node)
		.find((node) => !node.parent)?.id;

	return (
		<Modal width={400} height="auto">
			<Modal.Header title={t('settings.departments.createDepartment.title')} />
			<Modal.Contents>
				<Label mb={2}>{t('settings.departments.createDepartment.name.label')}:</Label>
				{groups.data ? (
					<Input
						value={name}
						onChange={setName}
						autoFocus
						inputProps={{
							'aria-label': t('settings.departments.createDepartment.name.label'),
						}}
					/>
				) : (
					<Input.Skeleton />
				)}
			</Modal.Contents>
			<Modal.FormFooter
				disabled={name.length === 0 || !groups.data}
				onCancel={props.onDismiss}
				onSave={async () => {
					const response = await create({
						variables: {
							input: {
								name,
								type: graphql.GroupType.Department,
								parentID,
							},
						},
					});
					history.push(`/settings/organization/departments/${response.data!.createGroup.group.id}`);
				}}
			/>
		</Modal>
	);
}

export default function CreateDepartment() {
	const { t } = useTranslation();
	const [visible, setVisible] = useState(false);
	const { isHRBusinessPartner } = useViewerRoles();

	if (isHRBusinessPartner) return null;

	return (
		<Popover.Target
			backdrop
			contents={<CreateDepartmentPopover onDismiss={() => setVisible(false)} />}
			visible={visible}
		>
			<Button
				type="secondary"
				title={t('settings.departments.createDepartment.button')}
				icon={<AddIcon />}
				onClick={() => setVisible(true)}
			/>
		</Popover.Target>
	);
}
